import React from 'react'
import { AppLinks } from '../../shared/legacy/app-links'
import { CardFullHeight } from '../../shared/card/card-full-height'
import { useAdminNavigation } from '../../role/hook/admin-navigation'
import { LearnerLanding } from './learner-landing'

// /download/links: the landing for anyone without the dashboard. Someone with
// no admin navigation at all gets the learner landing (where they are, open
// your courses in the app, the downloads); anyone else keeps the downloads.
export const DownloadLinks = () => {
  const adminNavigation = useAdminNavigation()

  if (adminNavigation.ready && !adminNavigation.has) {
    return <LearnerLanding />
  }

  return (
    <React.Fragment>
      <CardFullHeight title="downloads">
        <AppLinks />
      </CardFullHeight>
    </React.Fragment>
  )
}
